module.exports = __webpack_public_path__ + "a4c8756874c5e2dc9a1f886ace10390d.pdf";